import * as React from 'react';
import moment from 'moment';
import { connect, Dispatch } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../redux-state/interfaces/text/calendar-app.text';
import MonthSelectionDropdownView from './month-selection-dropdown.view';
import { goToMonth } from '../../redux-state/actions/calendar.actions';
import { removeLoader } from '../../helpers/scroll-to-month';


interface IMonthSelectionDropdownExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    currentMonth: moment.Moment;
    validMonths: moment.Moment[];
}

interface DispatchToProps {
    goToMonth: (date: moment.Moment) => void;
}

export type MonthSelectionDropdownProps = IMonthSelectionDropdownExternalProps & StateToProps & DispatchToProps;

export class MonthSelectionDropdownBase extends React.Component<MonthSelectionDropdownProps, any> {
    render() {
        return (
            <MonthSelectionDropdownView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IMonthSelectionDropdownExternalProps): StateToProps {
    return {
        text: state.calendarText,
        currentMonth: state.calendar.currentDate,
        validMonths: state.calendarSettings.monthsOnCalendar
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        goToMonth: (date: moment.Moment) => {
            dispatch(goToMonth(date))
            setTimeout(() => removeLoader(), 2000);
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(MonthSelectionDropdownBase);